const Constants = {
  ENV: process.env.REACT_APP_ENV,
  BASE_URL: process.env.REACT_APP_BASE_URL,
  REDIRECT_URL: process.env.REACT_APP_DEV_URL,
  AUTHORITY: "https://login.microsoftonline.com/common",
};
  
  export default Constants;